(() => {
  const AUDIENCES = [
    { label: 'Damen', key: 'damen' },
    { label: 'Herren', key: 'herren' },
    { label: 'Kinder', key: 'kinder' }
  ];
  const CATEGORIES = [
    { label: 'Bekleidung', key: 'bekleidung', tag: 'category:bekleidung_lvl_1', fallback: '/collections/bekleidung' },
    { label: 'Schuhe', key: 'schuhe', tag: 'category:schuhe_lvl_1', fallback: '/collections/schuhe' },
    { label: 'Ausrüstung', key: 'ausrustung', tag: 'category:ausruestung_lvl_1', fallback: '/collections/ausruestung' },
    { label: 'Activity', key: 'activity', fallback: '/collections/all' },
    { label: 'Marken', key: 'marken', fallback: '/collections/all' },
    { label: 'SALE', key: 'sale', fallback: '/collections/sale-25', sale: true }
  ];
  const AUDIENCE_FILTERS = {
    damen: ['gid://shopify/Metaobject/107696062552', 'gid://shopify/Metaobject/107696128088'],
    herren: ['gid://shopify/Metaobject/107696095320', 'gid://shopify/Metaobject/107696128088'],
    kinder: ['gid://shopify/Metaobject/107696160856', 'gid://shopify/Metaobject/107696193624', 'gid://shopify/Metaobject/107696291928']
  };
  const availabilityMemory = new Map();

  const registry = () => window.PeakStyleCategoryRegistry;
  const normalize = (value) => String(value || '').trim().toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '');
  const text = (node) => (node?.textContent || '').trim().replace(/\s+/g, ' ');
  const panelFor = (audience, category) => document.querySelector('.ps-mega__panel[data-panel="' + audience + ':' + category + '"]');
  const nodeHasProducts = (node) => Number(node.count) > 0 || (node.children || []).some(nodeHasProducts);

  const parseTree = (id) => {
    const source = document.getElementById(id);
    if (!source) return [];
    try { return JSON.parse(source.textContent || '[]'); } catch (error) { return []; }
  };
  const brandTree = () => parseTree('PeakStyleMobileBrandTree');

  const withAudience = (rawUrl, audience) => registry()?.withAudience(rawUrl, AUDIENCE_FILTERS[audience] || []) || rawUrl;
  const allHref = (panel, fallback) => panel?.querySelector('.ps-mega__all-link[href], .ps-mega__category-group--all a[href]')?.getAttribute('href') || fallback;

  const uniqueLinks = (nodes) => {
    const seen = new Set();
    return [...nodes].reduce((result, anchor) => {
      const label = text(anchor);
      const href = anchor.getAttribute('href');
      const signature = normalize(label) + '|' + href;
      if (!label || !href || seen.has(signature)) return result;
      seen.add(signature);
      result.push({ label, href, children: [], count: 1 });
      return result;
    }, []);
  };

  const collectPanel = (panel, category, fallback) => {
    if (!panel) return [];
    const groups = [...panel.querySelectorAll('.ps-mega__category-group:not(.ps-mega__category-group--all)')].map((group) => {
      const heading = group.querySelector('h3 a[href]');
      if (!heading) return null;
      return { label: text(heading), href: heading.getAttribute('href'), children: uniqueLinks([...group.children].filter((child) => child.matches?.('a[href]'))), count: 1 };
    }).filter(Boolean);
    if (groups.length) {
      if (category === 'sale') {
        const discounts = uniqueLinks(panel.querySelectorAll('.ps-mega__sale-discount-grid a[href]'));
        if (discounts.length) groups.push({ label: 'Nach Rabatt', href: allHref(panel, fallback), children: discounts, hideAllLink: true, count: 1 });
      }
      return groups;
    }
    return uniqueLinks(panel.querySelectorAll('.ps-mega__activity-card[href], .ps-mega__brand-link[href], .ps-mega__brand-tile[href], .ps-mega__sale-discount-grid a[href]'));
  };

  const registryEntry = (node, audience) => ({
    label: node.title,
    href: withAudience(node.url, audience),
    count: node.count,
    children: (node.children || []).filter(nodeHasProducts).map((child) => registryEntry(child, audience))
  });

  const categoryEntry = (audience, category) => {
    if (category.tag) {
      const root = registry()?.tree?.find((node) => node.tag === category.tag);
      if (root) return { label: category.label, href: withAudience(root.url || category.fallback, audience), count: root.count, children: (root.children || []).filter(nodeHasProducts).map((node) => registryEntry(node, audience)) };
    }
    const panel = panelFor(audience || 'all', category.key);
    return {
      label: category.label,
      href: allHref(panel, category.fallback),
      sale: category.sale,
      count: 1,
      children: category.key === 'marken'
        ? brandTree().map((entry) => ({ ...entry, href: withAudience(entry.href, audience), count: 1 }))
        : collectPanel(panel, category.key, category.fallback)
    };
  };

  const audienceEntry = (audience) => ({
    label: audience.label,
    href: withAudience('/collections/all', audience.key),
    count: 1,
    children: CATEGORIES.map((category) => categoryEntry(audience.key, category)).filter(Boolean)
  });

  const availability = async (rawUrl) => {
    const url = new URL(rawUrl, window.location.origin);
    url.searchParams.delete('page');
    const key = url.pathname + '?' + url.searchParams.toString();
    if (availabilityMemory.has(key)) return availabilityMemory.get(key);
    const promise = fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => response.ok ? response.text() : '')
      .then((html) => {
        const match = html.match(/data-peakstyle-category-navigation[^>]*data-results-count="(\d+)"/i);
        const value = match ? Number(match[1]) > 0 : true;
        availabilityMemory.set(key, value);
        return value;
      }).catch(() => true);
    availabilityMemory.set(key, promise);
    return promise;
  };

  const verifyDirectChildren = async (list) => {
    if (!list || list.dataset.psAvailabilityChecked === 'true') return;
    list.dataset.psAvailabilityChecked = 'true';
    const items = [...list.children].filter((item) => item.dataset.psCategoryUrl);
    let index = 0;
    const worker = async () => {
      while (index < items.length) {
        const item = items[index++];
        if (!(await availability(item.dataset.psCategoryUrl))) item.remove();
      }
    };
    await Promise.all(Array.from({ length: Math.min(4, items.length) }, worker));
  };

  const closeSiblings = (item) => {
    item.parentElement?.querySelectorAll(':scope > li.is-open').forEach((sibling) => {
      if (sibling === item) return;
      sibling.classList.remove('is-open');
      sibling.querySelector(':scope > button[aria-expanded]')?.setAttribute('aria-expanded', 'false');
      const submenu = sibling.querySelector(':scope > ul');
      if (submenu) submenu.hidden = true;
    });
  };
  const chevron = () => '<span class="ps-mobile-menu__chevron" aria-hidden="true"></span>';

  const addAllLink = (list, href, hidden) => {
    if (!href || hidden) return;
    const item = document.createElement('li');
    item.className = 'ps-mobile-menu__all-item';
    const link = document.createElement('a');
    link.className = 'ps-mobile-menu__all-link';
    link.href = href;
    link.textContent = 'Alles entdecken';
    item.appendChild(link);
    list.appendChild(item);
  };

  const createBranch = (entry, topLevel = false, depth = 0) => {
    const item = document.createElement('li');
    item.className = topLevel ? 'f-mobile-nav__item ps-mobile-menu__generic-item' + (entry.sale ? ' ps-mobile-menu__generic-item--sale' : '') : 'ps-mobile-menu__group-item';
    item.dataset.psMenuDepth = String(depth);
    item.dataset.psCategoryUrl = entry.href || '';

    if (!entry.children?.length) {
      const link = document.createElement('a');
      link.href = entry.href;
      link.className = topLevel ? 'f-mobile-nav__link ps-mobile-menu__branch-link' : 'ps-mobile-menu__branch-link';
      link.innerHTML = '<span>' + entry.label + '</span>' + chevron();
      item.appendChild(link);
      return item;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = topLevel ? 'ps-mobile-menu__generic-toggle' : 'ps-mobile-menu__group-toggle';
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = '<span>' + entry.label + '</span>' + chevron();

    const submenu = document.createElement('ul');
    submenu.className = topLevel ? 'ps-mobile-menu__generic-submenu' : 'ps-mobile-menu__group-submenu';
    submenu.hidden = true;
    addAllLink(submenu, entry.href, entry.hideAllLink);
    entry.children.forEach((child) => submenu.appendChild(createBranch(child, false, depth + 1)));

    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      closeSiblings(item);
      item.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      submenu.hidden = !open;
      if (open) {
        verifyDirectChildren(submenu);
        requestAnimationFrame(() => button.scrollIntoView({ block: 'nearest', behavior: 'smooth' }));
      }
    });
    item.append(button, submenu);
    return item;
  };

  const directLabel = (item) => {
    const node = item.querySelector(':scope > .f-mobile-nav__link, :scope > button, :scope > collapsible-tab > .f-mobile-nav__link, :scope > collapsible-tab > .f-mobile-nav__item-header > .f-mobile-nav__link');
    return normalize(text(node));
  };

  const replaceAliases = (root, aliases, replacement) => {
    const wanted = aliases.map(normalize);
    const target = [...root.children].find((item) => item.matches('li') && wanted.includes(directLabel(item)));
    if (target) target.replaceWith(replacement); else root.appendChild(replacement);
  };

  const enhanceDrawer = (drawer) => {
    const root = drawer.querySelector('.f-mobile-nav__inner > ul');
    if (!root || root.dataset.psCentralStructureReady === 'true' || !registry()?.tree?.length) return;

    AUDIENCES.forEach((audience) => replaceAliases(root, [audience.label], createBranch(audienceEntry(audience), true)));
    CATEGORIES.filter((category) => category.tag).forEach((category) => {
      const aliases = [category.label, category.label + ' – ohne zielgruppe', category.label + ' - ohne zielgruppe'];
      replaceAliases(root, aliases, createBranch(categoryEntry('all', category), true));
    });
    ['activity', 'marken', 'sale'].forEach((key) => {
      const category = CATEGORIES.find((entry) => entry.key === key);
      replaceAliases(root, [category.label], createBranch(categoryEntry('all', category), true));
    });
    root.dataset.psCentralStructureReady = 'true';
  };

  const init = () => document.querySelectorAll('.f-drawer-mobile-nav').forEach(enhanceDrawer);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('peakstyle:category-registry-ready', init);
  document.addEventListener('shopify:section:load', init);
  requestAnimationFrame(init);
})();